<template>
  <dl class="icons-landing-stats margin-0 padding-0 display-flex flex-wrap flex-items-center flex-content-center">
    <dt class="sr-only">About Font Awesome Icons</dt>
    <dd class="icons-landing-stat size-sm margin-bottom-0">
      <font-awesome-icon
        :icon="$v6.solid.faShapes"
        class="margin-right-3xs"
        fixed-width
        size="lg"
      />
      <site-link
        :to="$search()"
        @click.native="$posthog.capture('icons_landing:stats_link_click', { stat: 'total_icons', location: 'icons_stats' })"
      >
        {{ $counts.icons.all.formatted }} Icons
      </site-link>
    </dd>

    <dd class="icons-landing-stat size-sm margin-bottom-0">
      <font-awesome-icon
        :icon="$v6.solid.faGift"
        class="margin-right-3xs"
        fixed-width
        size="lg"
      />

      <site-link
        :to="{ hash: '#packs' }"
        @click.native="
          () => {
            $posthog.capture('icons_landing:stats_link_click', { stat: 'total_packs', location: 'icons_stats' })
            setSelectedTab('packs')
          }
        "
      >
        {{ iconPacksCount }} Icon Packs
      </site-link>
    </dd>

    <dd class="icons-landing-stat size-sm margin-bottom-0">
      <font-awesome-icon
        :icon="$v6.solid.faPalette"
        class="margin-right-3xs"
        fixed-width
        size="lg"
      />
      <site-link
        :to="$search()"
        @click.native="$posthog.capture('icons_landing:stats_link_click', { stat: 'total_styles', location: 'icons_stats' })"
      >
        {{ $counts.totalLatestStylesWithoutBrands }} Icon Styles
      </site-link>
    </dd>

    <dd class="icons-landing-stat size-sm margin-bottom-0">
      <font-awesome-icon
        :icon="$v6.solid.faFolder"
        class="margin-right-3xs"
        fixed-width
        size="lg"
      />

      <site-link
        :to="{ hash: '#categories' }"
        @click.native="
          () => {
            $posthog.capture('icons_landing:stats_link_click', { stat: 'total_categories', location: 'icons_stats' })
            setSelectedTab('categories')
          }
        "
      >
        {{ iconCategoriesCount }} Categories
      </site-link>
    </dd>

    <dd class="icons-landing-stat size-sm margin-bottom-0">
      <font-awesome-icon
        :icon="$v6.solid.faSparkles"
        class="margin-right-3xs"
        fixed-width
        size="lg"
      />
      <site-link
        :to="$docs('/web/add-icons/icon-wizard')"
        @click.native="$posthog.capture('icons_landing:stats_link_click', { stat: 'total_icon_wizard_possibilities', location: 'icons_stats' })"
      >
        1.8 Million Icon Possibilities</site-link
      >
    </dd>
  </dl>
</template>

<script>
  // TODO V7: update this and computed below for V7 categories
  const categoryIcons = require('app/views/icons/category-figures/v6.json')
  import collection_data_v6 from 'app/views/search/collections-v6.json'

  export default {
    name: 'IconsStats',

    inject: ['selectedTab', 'setSelectedTab'],

    computed: {
      iconCategoriesCount() {
        return categoryIcons.length
      },

      iconPacksCount() {
        return collection_data_v6['icon-packs'].length
      }
    }
  }
</script>
